import type { CreateUserInput, UpdateUserInput } from '@idc-forms/schemas'
import { axiosPrivate } from '@/shared/api/axios'
import { buildListQueryString } from '@/shared/api/build-list-query-string'
import { API } from '@/shared/constants/api'
import type { PaginatedUsers, UserAdminRow, UsersAdminParams } from '../models/user-admin'

export async function getUsersAdmin(params: UsersAdminParams): Promise<PaginatedUsers> {
  const qs = buildListQueryString(params)
  const { data } = await axiosPrivate.get<PaginatedUsers>(`${API.users.root}${qs ? `?${qs}` : ''}`)
  return data
}

/**
 * Los payloads son los MISMOS schemas Zod que valida el backend. El create no
 * lleva password: el backend genera uno aleatorio y lo envía por correo.
 */
export async function createUser(payload: CreateUserInput): Promise<UserAdminRow> {
  const { data } = await axiosPrivate.post<UserAdminRow>(API.users.root, payload)
  return data
}

export async function updateUser(id: string, payload: UpdateUserInput): Promise<UserAdminRow> {
  const { data } = await axiosPrivate.patch<UserAdminRow>(API.users.byId(id), payload)
  return data
}

export async function deleteUser(id: string) {
  const { data } = await axiosPrivate.delete(API.users.byId(id))
  return data
}

/** Genera una contraseña nueva y se la envía por correo al usuario. */
export async function resetUserPassword(id: string): Promise<{ sent: true; email: string }> {
  const { data } = await axiosPrivate.post<{ sent: true; email: string }>(
    `${API.users.byId(id)}/password-reset`
  )
  return data
}
